// GeometryService.js

//============================================================================
//
// Geometric utilities singleton
//
// Lou Mauget, November 23, 2015
//
//============================================================================

class GeometryService {

	//========================================================================
	// rect = { top: Number, left: Number, height: Number, width: Number }
	// returns true if rectangle r2 wholly contained by rectangle r1.
	//
	// That means no border overlap.
	//
	// Note that the values are all Numbers. They can be fractional, but they
	// cannot have units -- that would be a String, not a number.
	// E.g. 123px (not accepted); 123 (acceptable).
	//=======================================================================
	rect1ContainsRect2( r1, r2 ) { 
		
		// Checking if it was dropped either at the left , right,bottom and top edges of the canvas but still inside the form
		return (((r1.left < r2.left) || (r1.left < (r2.left + r2.width)))  &&
		((r1.top < r2.top) || (r1.top < (r2.top + r2.height)))) &&
			((r2.left  < (r1.left + r1.width))) &&
			((r2.top   < (r1.top + r1.height)));
	}


    rect1ContainsPartiallyRect2( r1, r2 ) {

        // Checking if it was dropped either at the left , right,bottom and top edges of the canvas but still inside the form

        return (((r1.left < r2.left) || (r1.left < (r2.left + r2.width)))  &&
            ((r1.top < r2.top) || (r1.top < (r2.top + r2.height))));
    }


	//========================================================================
	// Two rectangles DO NOT overlap if ONE of the these conditions is true:
	//   1) One rectangle is left of left edge of other rectangle.
	//   2) One rectangle is above top edge of other rectangle.
	//
	// Returns true if and only if two rectangles, r1 and r2, overlap
	//========================================================================
	rect1OverlapsRect2( r1, r2 ) {

        // Is one rectangle left of left side of the other?
        // OR is one rectangle is above other?
        // i.e. if both clauses are false, then r1 and r2 overlap.
        return !(
            ( (r1.left + r1.width) < r2.left || (r2.left + r2.width) < r1.left) // no horizontal overlap
                ||
            ( (r1.top + r1.height) < r2.top || (r2.top + r2.height) < r1.top)  // no vertical overlap
        );

	}
	
	 //==========================================================================================
    // Property true if elemRect overlap current PF page rectangle by at least 50% both
    // horizontally and vertically
    //==========================================================================================
    isValidOverlapping(pageRect, elemRect) {
		let overlapped = this.rect1OverlapsRect2(pageRect, elemRect); 
		
        if (overlapped) { //Check if overlap is at least 50%
            let verticalOverlap = (elemRect.top + elemRect.height) >= (elemRect.height / 2) && (pageRect.height - elemRect.top) >= (elemRect.height / 2);
            let horizontalOverlap = (elemRect.left + elemRect.width) >= (elemRect.width / 2) && (pageRect.width - elemRect.left) >= (elemRect.width / 2);

            overlapped = verticalOverlap && horizontalOverlap; 
        }

        return overlapped;
    }
}

const geometryService = new GeometryService(); 
export default geometryService;
